import { render, staticRenderFns } from "./secureupgrade-wraper.vue?vue&type=template&id=c1cf3aaa&scoped=true&"
import script from "./secureupgrade-wraper.vue?vue&type=script&lang=tsx&"
export * from "./secureupgrade-wraper.vue?vue&type=script&lang=tsx&"
import style0 from "./secureupgrade-wraper.vue?vue&type=style&index=0&id=c1cf3aaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1cf3aaa",
  null
  
)

export default component.exports